export const encodeScopeValue = (scopeType, scopeId) => {
  if (scopeType === 'my_calendly') return 'my_calendly'

  return scopeId != null && scopeId !== '' ? `${scopeType}:${scopeId}` : scopeType
}

export const decodeScopeValue = (value) => {
  const separatorIndex = String(value).indexOf(':')

  if (separatorIndex === -1) {
    return { type: value, id: undefined }
  }

  return {
    type: value.slice(0, separatorIndex),
    id: value.slice(separatorIndex + 1),
  }
}

export const ALL_SCOPE_VALUES = {
  all_users: 'all_users',
  all_teams: 'page',
  all_users_and_teams: 'all_users_and_teams',
}
